import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Input } from "reactstrap";
import "./index.scss";
import FilterFile from "./FilterFile";
import AutoPopulateList from "../../../../components/common/AutoPopulateList";
import { useDispatch } from "react-redux";
import { rightsidebar } from "../../../../context/actions/document";
import { useHistory } from "react-router-dom";

const DocSearchBlock = ({
	filterSelectedFn, sortBySelectedFn,
	filterSelected, sortBySelected,
	_handleSearch, _filterDocs, __filterDocs, _resetFilter, _handleElasticSearch, elasticSearchList, focusSearchFlag, __focusSearch }) => {
	const dispatch = useDispatch()
	const history = useHistory()
	// const [filterSelected, setFilterSelected] = useState();
	// const [sortBySelected, setSortBySelected] = useState();
	const [keyword, setKeyword] = useState('')
	const [focusSearch, setFocusSearch] = useState(false);

	/*const __handleSearch = (val) => {
		if (val.trim() && val.trim().replace(/\./g, "")){
			setKeyword(val)
			_handleSearch(val);
		}else{
			setKeyword(val.trim().replace(/\./g, ""))
			_handleSearch(val.trim().replace(/\./g, "") || ' ');
		}
	};*/
	/***
	 * @description function use for handle restElasticSearch
	 */
	const restElasticSearch = () => {
		setKeyword('')
		setFocusSearch(false)
		_handleSearch(null);

	}
	const resetDocs = (v) => {
		dispatch(rightsidebar("D"))
		_resetFilter(v)
		setKeyword('')
		filterSelectedFn(null)
		sortBySelectedFn(null)
		history.push('/documentDetail');
		//setFilterSelected(null);
		//setSortBySelected(null);
	}

	/***
	 * @description function use for search trigger
	 * @param {refObj} event accepting element event 
	 */
	const onKeyDownEvent = (event) => {
		if (event.key === 'Enter') {
			if (elasticSearchList.length) {
				if (event.target.value.trim() && event.target.value.trim().replace(/\./g, "")) {
					setKeyword(event.target.value)
					setFocusSearch(false)
					_handleSearch(event.target.value);
				} else {
					setKeyword(event.target.value.trim().replace(/\./g, ""))
					setFocusSearch(false)
					_handleSearch(null);
				}
			}
		}
	}


	const __handleElasticSearch = (val) => {
		if (val.trim() && val.trim().replace(/\./g, "")) {
			setFocusSearch(true)
			setKeyword(val)
			_handleElasticSearch(val.trim());
		} else {
			setFocusSearch(false)
			setKeyword(val.trim().replace(/\./g, ""));
			_handleSearch(null)
		}

	};


	const handleSelectedAction = async (val) => {
		dispatch({ type: "RESET_DATA", data: [] }); // reset data (issue 382)
		setKeyword(val)
		setFocusSearch(false)
		_handleSearch(val);



	}

	/***
	 * @description function use for handle elastic search view more
	 */
	const viewMore = () => {
		setFocusSearch(false)
		_handleSearch(keyword);

	}

	const onClick = (v) => {
		__focusSearch(true);
		if (keyword) {
			_handleElasticSearch(keyword.trim());
		}
	}
	return (
		<>
			<div className="docs-search-blc position-relative d-flex align-items-center position-relative">
				<Input type="text" value={keyword} placeholder="Search" onChange={(e) => { if (e.target.value != " ") { __handleElasticSearch(e.target.value) } }} onClick={(e) => { onClick(e.target.value) }}
					onKeyDown={(e) => {
						if (e.key === '.') {
							e.stopPropagation();
							e.preventDefault();
						} else {
							onKeyDownEvent(e)
						}

					}} />
				<span className="icon position-absolute d-inline-flex align-items-center justify-content-center">
					<FontAwesomeIcon icon={faSearch} />
				</span>
				{/* <FilterFile className="filter-blc position-absolute" _filterSelected={filterSelected} _sortBySelected={sortBySelected} _filter={(v) => { _filterDocs(v); setFilterSelected(Number(v)) }} __filter={(sortBy, order, v) => { __filterDocs(sortBy, order); setSortBySelected(v) }} /> */}
				<FilterFile className="filter-blc position-absolute" _filterSelected={filterSelected} _sortBySelected={sortBySelected} _filter={(v) => { _filterDocs(v); filterSelectedFn(Number(v)) }} __filter={(sortBy, order, v) => { __filterDocs(sortBy, order); sortBySelectedFn(v) }} />
				<Button data-toggle="tooltip" data-placement="top" title={'Reset'} color="link" onClick={resetDocs} className="reset-btn  position-absolute">
					<FontAwesomeIcon icon={faRedoAlt} />
				</Button>
				{focusSearch && focusSearchFlag && (
					<AutoPopulateList searchList={elasticSearchList} _handleSelectedAction={(val) => handleSelectedAction(val)} _handleFilePageChange={viewMore} _resetSearch={restElasticSearch} type='document' />
				)}
			</div>
		</>
	)
};
export default DocSearchBlock;